import React from 'react';
import { FiUser, FiMail, FiGlobe, FiShield } from 'react-icons/fi';
import { useAuth } from '../../../context/AuthContext';
import './AdminSettings.css';

const AdminSettings = () => {
    const { user } = useAuth();

    return (
        <div className="admin-settings-page">
            <div className="settings-banner">
                <div className="banner-content">
                    <span className="banner-tag">Settings</span>
                    <h1 className="banner-title">Admin <span>Profile</span></h1>
                    <p className="banner-subtitle">View your registered administrative account details.</p>
                </div>
                <div className="banner-visual-glow"></div>
            </div>

            <div className="settings-layout-single">
                <div className="settings-content">
                    <div className="settings-card glass-panel animate-in">
                        <div className="card-header">
                            <h3>Profile Details</h3>
                            <p>Your official registered credentials.</p>
                        </div>
                        
                        <div className="avatar-upload-section">
                            <div className="profile-avatar-large">
                                {user?.fullName?.charAt(0) || 'A'}
                            </div>
                            <div className="avatar-meta">
                                <h4>Admin Identity</h4>
                                <p>System Core User</p>
                            </div>
                        </div>

                        <div className="settings-form-grid">
                            <div className="form-group">
                                <label>Full Name</label>
                                <div className="input-with-icon">
                                    <FiUser className="input-icon" />
                                    <input 
                                        type="text" 
                                        value={user?.fullName || 'Not Provided'}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Email Address</label>
                                <div className="input-with-icon">
                                    <FiMail className="input-icon" />
                                    <input 
                                        type="email" 
                                        value={user?.email || 'Not Provided'}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Phone Number</label>
                                <div className="input-with-icon">
                                    <FiGlobe className="input-icon" />
                                    <input 
                                        type="text" 
                                        value={user?.phone || 'Not Provided'}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Role Level</label>
                                <div className="input-with-icon">
                                    <FiShield className="input-icon" />
                                    <input 
                                        type="text" 
                                        value={(user?.role || 'Admin').toUpperCase()}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;

